import { Edit2, Share2 } from 'lucide-react';
import { Flex, Text } from '@chakra-ui/react';

interface ProfileActionsProps {
  onEdit: () => void;
  onShare: () => void;
}

export function ProfileActions({ onEdit, onShare }: ProfileActionsProps) {
  return (
    <Flex justify="center" gap="12px" mt="80px" mb="24px" px="20px" align="center">
      <Flex
        as="button"
        align="center"
        bg="volyx.lightGray"
        px="16px"
        py="8px"
        borderRadius="20px"
        gap="8px"
        border="none"
        cursor="pointer"
        _hover={{ bg: "volyx.borderLight" }}
        onClick={onEdit}
      >
        <Edit2 size={20} />
        <Text as="span" fontSize="14px" fontWeight="medium" color="volyx.text">Edit Profile</Text>
      </Flex>
      <Flex
        as="button"
        align="center"
        bg="volyx.lightGray"
        px="16px"
        py="8px"
        borderRadius="20px"
        gap="8px"
        border="none"
        cursor="pointer"
        _hover={{ bg: "volyx.borderLight" }}
        onClick={onShare}
      >
        <Share2 size={20} />
        <Text as="span" fontSize="14px" fontWeight="medium" color="volyx.text">Share</Text>
      </Flex>
    </Flex>
  );
}
